/**
 * Action types for kube nodes functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of kube nodes.
 */

// Get kube nodes constants
export const KUBE_NODES_REQUEST_GET = 'KUBE_NODES_REQUEST_GET';
export const KUBE_NODES_RESPONSE_GET_SUCCESS = 'KUBE_NODES_RESPONSE_GET_SUCCESS';
export const KUBE_NODES_RESPONSE_GET_FAIL = 'KUBE_NODES_RESPONSE_GET_FAIL'
